// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".money-input[data-v-280da98e] {\n  max-width: 6.5em;\n}\n.quantity-input[data-v-280da98e] {\n  max-width: 3.5em;\n}\n.description-input[data-v-280da98e] {\n  width: 18em;\n}\n.account-input[data-v-280da98e] {\n  width: 18em;\n}", ""]);
// Exports
module.exports = exports;
